import React, { useState } from 'react';
import FullPageSection from './FullPageSection';
import { contactAPI } from '../services/api';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { useToast } from '../hooks/use-toast';
import './ContactSection.css';

const ContactSection = () => {
    const { toast } = useToast();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        company: '',
        message: '',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const response = await contactAPI.submitContact(formData);
            
            toast({
                title: "Mensagem enviada!",
                description: response.message,
                variant: "default",
            });

            // Reset form
            setFormData({
                name: '',
                email: '',
                company: '',
                message: '',
            });
        } catch (error) {
            toast({
                title: "Erro ao enviar mensagem",
                description: "Por favor, tente novamente mais tarde.",
                variant: "destructive",
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <FullPageSection id="contact" className="contact-section">
            <div className="contact-container">
                <div className="contact-content">
                    <div className="contact-info">
                        <span className="section-label">Contacto</span>
                        <h2 className="section-title">
                            Vamos<br />
                            Desenhar<br />
                            Juntos
                        </h2>
                        <p className="contact-description">
                            Pronto para criar algo incrível? Entre em contacto e vamos 
                            conversar sobre o seu projeto.
                        </p>

                        <div className="contact-details">
                            <div className="contact-item">
                                <span className="contact-label">Email</span>
                                <a href="mailto:contato@mapdesign.pt" className="contact-value">
                                    contato@mapdesign.pt
                                </a>
                            </div>
                            <div className="contact-item">
                                <span className="contact-label">Behance</span>
                                <a
                                    href="https://www.behance.net/newwdc"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="contact-value"
                                >
                                    @newwdc
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="contact-form-wrapper">
                        <form onSubmit={handleSubmit} className="contact-form">
                            <div className="form-group">
                                <label htmlFor="name">Nome *</label>
                                <Input
                                    id="name"
                                    name="name"
                                    type="text"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    placeholder="O seu nome"
                                    disabled={isSubmitting}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">Email *</label>
                                <Input
                                    id="email"
                                    name="email"
                                    type="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    placeholder="seuemail@exemplo.com"
                                    disabled={isSubmitting}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="company">Empresa</label>
                                <Input
                                    id="company"
                                    name="company"
                                    type="text"
                                    value={formData.company}
                                    onChange={handleChange}
                                    placeholder="Nome da empresa (opcional)"
                                    disabled={isSubmitting}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="message">Mensagem *</label>
                                <Textarea
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                    placeholder="Conte-nos sobre o seu projeto..."
                                    rows={6}
                                    disabled={isSubmitting}
                                />
                            </div>

                            <Button
                                type="submit"
                                className="submit-btn"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'A enviar...' : 'Enviar Mensagem'}
                            </Button>
                        </form>
                    </div>
                </div>
            </div>
        </FullPageSection>
    );
};

export default ContactSection;
